import { __decorate, __metadata } from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
export const GROUPS = "groups";
export const ROLES = "roles";
export const PERMISSIONS = "permissions";
let Authorization = class Authorization {
    constructor() {
        this.Groups = [];
        this.Roles = [];
        this.Permissions = [];
    }
};
__decorate([
    JsonProperty(GROUPS, [String], true),
    __metadata("design:type", Array)
], Authorization.prototype, "Groups", void 0);
__decorate([
    JsonProperty(ROLES, [String], true),
    __metadata("design:type", Array)
], Authorization.prototype, "Roles", void 0);
__decorate([
    JsonProperty(PERMISSIONS, [String], true),
    __metadata("design:type", Array)
], Authorization.prototype, "Permissions", void 0);
Authorization = __decorate([
    JsonObject("Authorization")
], Authorization);
export { Authorization };
